export const FORECAST_VIEW_TYPE = {
    GRAPH: 0,
    TABLE: 1,
};

export const FORECAST_SKU_TYPE = {
    SINGLE: 0,
    BUNDLED: 1,
};
